module.exports = __webpack_public_path__ + "static/media/proxxmu-storyboard3.aec26bef.png";